import { lazy } from 'react';

export const Home = lazy(() => import('./home'));
export const Devices = lazy(() => import('./devices'));
export const Packages = lazy(() => import('./packages'));
export const Receipts = lazy(() => import('./receipts'));
export const Permissions = lazy(() => import('./permissions'));
export const Integrations = lazy(() => import('./integrations'));
export const BusinessInfo = lazy(() => import('./business-info'));
export const Notifications = lazy(() => import('./notifications'));
export const PaymentMethods = lazy(() => import('./payment-methods'));
